import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  email: { value: "", matchMode: "equals" },
  profileType: { value: "", matchMode: "equals" }
};

export const useFilterUserStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
